export default "__VITE_ASSET__ClzHZ6FO__"